<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <span>
        <a-icon type="wallet" class="margin-right-small" />
        PIPELINE
      </span>
      <a-button-group
        :size="getScreen ? 'small' : 'default'"
      >
        <a-button @click="handleCreate" type="primary"
          v-if="isMarketing"
          ><a-icon
            type="plus"
            :class="getScreen ? '' : 'margin-right-small'"
          />{{ getScreen ? "" : "Create" }}</a-button
        >
        <a-button
          icon="download"
          :loading="loadingExport"
          @click="handleExport"
        >
        Download
        </a-button>
        <!-- <a-button @click="handleReload"
          ><a-icon
            type="reload"
            :class="getScreen ? '' : 'margin-right-small'"
          />{{ getScreen ? "" : "Reload" }}</a-button
        > -->
      </a-button-group>
    </div>
    <div class="wrapper-body">
      <a-card>
        <div class="m-display-flex space-between align-middle">
          <a-radio-group
            v-model="typeView"
            button-style="solid"
          >
            <a-radio-button value="board"> Board </a-radio-button>
            <a-radio-button value="tabular"> Tabular </a-radio-button>
          </a-radio-group>
          <div>
            Year
          <a-select
            v-model="year_transaction"
            >
              <a-select-option value="all">Display All Year&nbsp;</a-select-option>
              <a-select-option v-for="item in listPipelineYear" :key="item">{{
                item
              }}</a-select-option>
            </a-select>
          </div>
        </div>
      </a-card>
      <a-card v-if="typeView=='tabular'">
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
            <a-input-search v-model="search" placeholder="Quick Search" />
          </a-col>
          <!-- <a-col :xs="{ span: 24 }" :lg="{ span: 3 }">
            <a-button
              :class="getScreen ? 'margin-top' : ''"
              block
              :icon="advancedsearch == 'display:none' ? 'down' : 'up'"
              @click="handleshowMore"
              >{{
                advancedsearch == "display:none" ? "More" : "Less"
              }}</a-button
            >
          </a-col> -->
        </a-row>
        <!-- <a-row :style="advancedsearch" :gutter="16" class="margin-top">
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Status</label>
              <a-select
                placeholder="Ex: Prospect "
                v-model="sts_transaction"
                class="width-full"
                initialValue="all"
              >
                <a-select-option value="all">All Status</a-select-option>
                <a-select-option value="PROSPECT">PROSPECT</a-select-option>
                <a-select-option value="CONTRACT">CONTRACT</a-select-option>
                <a-select-option value="LOST">LOST</a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Pipeline Year</label>
              <a-select
                v-model="year_transaction"
                class="width-full"
                initialValue="all"
              >
                <a-select-option value="all">All Year</a-select-option>
                <a-select-option v-for="item in listPipelineYear" :key="item">{{
                    item
                  }}</a-select-option>
                </a-select>
            </div>
          </a-col>
        </a-row> -->
        <a-table
          :rowKey="(record, index) => {return index;}"
          :columns="columns"
          :dataSource="dataTable"
          :pagination="false"
          bordered
          size="small"
          class="margin-top"
          :scroll="{ x: 500 }"
        >
          <span slot="nomor" slot-scope="text, data, index">
            {{index+1}}
          </span>
          <span slot="create_tlc" slot-scope="text, data, index">
            {{data.year}} / {{data.tlc_create}}
          </span>
          <span slot="cd_dev" slot-scope="text, data, index">
            {{ data.pipeline_no }}<br/> <i>{{ data.definitions }}</i>
          </span>
          <span slot="status" slot-scope="item">
            <span>{{ item.status }}</span>
            <a-progress stroke-linecap="square" :percent="Number(item.prospect_progress)" />
          </span>
          <span slot="ecv" slot-scope="item">
            <span>{{ formatCurrency(item.currency, item.est_contract_value) }}</span>
          </span>
          <span slot="ec" slot-scope="item">
            <span>{{ formatCurrency(item.currency, 
            (item.est_finance_cost ? Number(item.est_finance_cost) : 0)+
            (item.est_ga_cost ? Number(item.est_ga_cost) : 0)+
            (item.est_marketing_cost ? Number(item.est_marketing_cost) : 0)+
            (item.est_operasional_cost ? Number(item.est_operasional_cost) : 0)
            ) }}</span>
          </span>
          <span slot="epl" slot-scope="item">
            <span>{{ formatCurrency(item.currency, 
            Number(item.est_contract_value)-(
            (item.est_finance_cost ? Number(item.est_finance_cost) : 0)+
            (item.est_ga_cost ? Number(item.est_ga_cost) : 0)+
            (item.est_marketing_cost ? Number(item.est_marketing_cost) : 0)+
            (item.est_operasional_cost ? Number(item.est_operasional_cost) : 0)
            )
            ) }}</span>
          </span>
          <span slot="aksi" slot-scope="text, data, index">
            <a-button @click="goTo(data)" size="small" type="primary" icon="eye">View</a-button>
          </span>
        </a-table>
      </a-card>
      <a-card v-if="typeView=='board'">
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
            <a-input-search v-model="search" placeholder="Quick Search" />
          </a-col>
        </a-row>
        <div style="width:100%;display: flex;justify-content: space-between;">
          <!-- <a-table
            :rowKey="
              (record, index) => {
                return index;
              }
            "
            :pagination="pagination"
            size="small"
            bordered
            :scroll="{ x: 1300 }"
            :columns="columns.pipeline"
            :dataSource="datasource"
            :loading="table.loading"
          >
            <template slot="nomor" slot-scope="text, data, index">
              <span>{{index+1}}</span>
            </template>
            <template slot="createdt" slot-scope="data">
              <span>{{moment(data.create_dt).format(getDefaultDateFormat)}}</span>
            </template>
            <template slot="sts" slot-scope="data">
              <a-tag v-if="data.status && data.status.toLowerCase()=='contract'" color="green">CONTRACT</a-tag>
              <a-tag v-if="data.status && data.status.toLowerCase()=='prospect'" color="orange">PROSPECT</a-tag>
              <a-tag v-if="data.status && data.status.toLowerCase()=='lost'" color="grey">LOST</a-tag>
            </template>
            <template slot="cd_dev" slot-scope="data">
              <span>
                <b>{{ data.pipeline_no }}</b> <br/>
                {{data.cost_center_kode}} <br/>
                <i>{{data.definitions}}</i></span>
            </template>
            <template slot="upval" slot-scope="data">
              <span>{{ formatCurrency(data.currency, data.up_value) }}</span>
            </template>
            <template slot="estcontryear" slot-scope="data">
              <span>{{ formatCurrency(data.currency, data.est_contract_value) }}</span>
            </template>
            <template slot="estgrossprofit" slot-scope="data">
              <span>{{ formatCurrency(data.currency, data.estimate_gross_profit) }}</span>
            </template>
            <template slot="progress" slot-scope="data">
              <a-progress :percent="data.progress ? Number(data.progress) : 0" />
            </template>
            <template slot="aksi" slot-scope="text, data">
                <a-button
                  @click="handleEdit(data)"
                  icon="edit"
                  type="danger"
                ></a-button>
            </template>
          </a-table> -->
          <div v-for="(data,index) in datasource" :key="index" style="width:24.5%">
            <a-collapse class="margin-top collapseItem" activeKey="1">
              <a-collapse-panel key="1">
                <h4 slot="header" class="margin-remove"><b>{{labelKanban[index].label}}</b></h4>
                <a-config-provider :locale="getLocalConfigProvider()">
                  <a-list
                    itemLayout="vertical"
                    :dataSource="data"
                  >
                    <a-list-item slot="renderItem" slot-scope="item" class="listItem" @click="editActivity(item)">
                      <a-list-item-meta>
                        <!-- <span slot="title" class="m-display-flex space-between align-middle" v-if="labelKanban[index].label!='PROSPECT'"> -->
                          <span slot="title" class="m-display-flex space-between align-middle">
                          <div class="width-full m-display-flex space-between">
                            <span>{{ item.cost_center_kode }}</span>
                            <Status v-if="item.status_besar" :status="item.status_besar" />
                          </div>
                        </span>
                        <div slot="description" class="margin-remove">
                          <a href="#"><b>{{ item.pipeline_no }}</b></a>
                          <div>{{ item.year }} | {{ item.tlc_create }}</div>
                          <a-progress v-if="item.status=='PROSPECT'" stroke-linecap="square" :percent="Number(item.prospect_progress)" />
                          <div>{{ item.client }}</div>
                          <div>{{ item.definitions }}</div>
                          <div><i><small>{{ item.description }}</small></i></div>
                        </div>
                      </a-list-item-meta>
                    </a-list-item>
                  </a-list>
                </a-config-provider>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </div>
      </a-card>
  </div>
    
    <a-table
      :rowKey="(record, index) => {return index;}"
      :columns="excel_columns"
      :dataSource="excel_table"
      :pagination="false"
      bordered
      class="ant-table-export-excel"
      size="small"
      style="display:none"
    >
      <template #title><h3>LIST PIPELINE {{ year_transaction!='all' ? year_transaction : 'ALL YEAR' }}</h3></template>
      <span slot="nomor" slot-scope="text, data, index">
        {{index+1}}
      </span>
      <span slot="est_contract_value" slot-scope="text, data, index">
        {{formatCurrency(data.currency,data.est_contract_value).replaceAll('Rp&nbsp;','')}}
      </span>
      <span slot="est_operasional_cost" slot-scope="text, data, index">
        {{formatCurrency(data.currency,data.est_operasional_cost).replaceAll('Rp&nbsp;','')}}
      </span>
      <span slot="est_marketing_cost" slot-scope="text, data, index">
        {{formatCurrency(data.currency,data.est_marketing_cost).replaceAll('Rp&nbsp;','')}}
      </span>
      <span slot="est_ga_cost" slot-scope="text, data, index">
        {{formatCurrency(data.currency,data.est_ga_cost).replaceAll('Rp&nbsp;','')}}
      </span>
      <span slot="est_finance_cost" slot-scope="text, data, index">
        {{formatCurrency(data.currency,data.est_finance_cost).replaceAll('Rp&nbsp;','')}}
      </span>
      <span slot="prospect_progress" slot-scope="text, data, index">
        {{data.prospect_progress}}%
      </span>
    </a-table>

    <a-modal
      v-if="modalCreate.visible"
      :visible="modalCreate.visible"
      @ok="submitCreateEdit"
      :width="getScreen ? '100%' : '80%'"
      @cancel="cancelmodalcreate"
      ok-text="Submit"
      cancel-text="Cancel"
      :maskClosable="false"
      :confirmLoading="modalCreate.loadingSave"
    >
      <span slot="title">
        <a-icon :type="modalCreate.type=='create' ? 'plus' : 'edit'" />&nbsp;{{modalCreate.type=='create' ? 'Create' : 'Edit'}} Pipeline
      </span>
      <a-form :form="formCreateEdit">
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-item label="Prospect No">
              <a-select
                showSearch
                allowClear
                option-filter-prop="children"
                :filter-option="filterOption"
                v-decorator="['id_prospek', {rules: [{required: false}], initialValue: modalCreate.data.id_prospek}]"
              >
                <a-select-option
                    v-for="karyawan in prospectList"
                    :key="karyawan.id_prospek"
                  >[{{karyawan.no_prospek}}] {{customer}} - {{karyawan.description}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Id" hidden>
              <a-input
                autocomplete="off"
                v-decorator="['pipeline_id', { rules: [{ required: false }], initialValue: modalCreate.data.pipeline_id}]"
              ></a-input>
            </a-form-item>
            <a-form-item label="Product">
              <a-input
                autocomplete="off"
                v-decorator="['definition', { rules: [{ required: true }], initialValue: modalCreate.data.definition }]"
              ></a-input>
            </a-form-item>
            <a-form-item label="Description">
              <a-input
                autocomplete="off"
                v-decorator="['description', { rules: [{ required: true }], initialValue: modalCreate.data.description }]"
              ></a-input>
            </a-form-item>
            <a-form-item label="Customer Name">
              <a-auto-complete
                autocomplete="off"
                v-decorator="['end_user', { rules: [{ required: true }], initialValue: modalCreate.data.end_user }]"
                class="certain-category-search"
                dropdownClassName="certain-category-search-dropdown"
                :dropdownMatchSelectWidth="false"
                placeholder="input here"
                optionLabelProp="value"
              >
                <template #dataSource>
                  <a-select-option v-for="cust in custNameList" :key="cust.customer_id" :value="cust.customer_nm.trim()">
                    {{ cust.customer_code }} {{ cust.customer_nm }}
                  </a-select-option>
                </template>
              </a-auto-complete>
            </a-form-item>
            <a-form-item label="Marketing/">
              <a-select
                showSearch
                allowClear
                option-filter-prop="children"
                :filter-option="filterOption"
                v-decorator="['pic', {rules: [{required: true}], initialValue: modalCreate.data.pic}]"
              >
                <a-select-option
                    v-for="karyawan in akun_Manager"
                    :key="karyawan.tlc"
                  >{{karyawan.tlc}} - {{karyawan.nama}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="PIMPRO">
              <a-select
                showSearch
                allowClear
                option-filter-prop="children"
                :filter-option="filterOption"
                v-decorator="['pimpro', { rules: [{ required: false }], initialValue: modalCreate.data.pimpro }]"
              >
                <a-select-option
                    v-for="karyawan in getAllKaryawan"
                    :key="karyawan.tlc"
                  >{{karyawan.tlc}} - {{karyawan.nama}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Contact Details">
              <a-input
                autocomplete="off"
                v-decorator="['contact_details', { rules: [{ required: false }], initialValue: modalCreate.data.contact_details }]"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-row :gutter="16" style="display:none">
              <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                <a-form-item label="Currency">
                  <a-select
                    placeholder="Select Currency"
                    v-decorator="['currency', { rules: [{ required: true }], initialValue: modalCreate.data.currency }]"
                    class="width-full"
                    initialValue
                    allowClear
                    @change="handleChangeCurrency"
                  >
                    <a-select-option
                      v-for="item in getAllMataUang"
                      :key="item.code"
                      :value="item.code"
                      >{{ item.code }} - {{ item.currency }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                <a-form-item :label="'Exchange rate'+lblxchangerate">
                  <a-input-number
                    type="number"
                    :min="0"
                    class="m-width-full m-text-numberRight"
                    :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                    :disabled="lblxchangerate==''"
                    v-decorator="['exchange_rate', { rules: [{ required: true }], initialValue: modalCreate.data.exchange_rate }]"
                  ></a-input-number>
                </a-form-item>
              </a-col>
            </a-row>
            <a-form-item label="Est. Contract value (IDR)">
              <a-input-number
                type="number"
                :min="0"
                class="m-width-full m-text-numberRight"
                :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                @keydown="onlyNumber"
                @change="changeestcontrak"
                v-decorator="['est_contract_value', { rules: [{ required: true }], initialValue: modalCreate.data.est_contract_value }]"
              ></a-input-number>
            </a-form-item>
            <!-- <a-form-item label="Est. Gross Profit">
              <div style="display: flex;gap:16px">
                <a-input-number
                  type="number"
                  :min="0"
                  :max="100"
                  class="m-text-numberRight" style="width: 30%;"
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  @keydown="onlyNumber"
                  @change="changeprosen"
                  v-decorator="['est_gross_profit_prosen', { rules: [{ required: true }], initialValue: modalCreate.data.est_gross_profit_prosen }]"
                ></a-input-number>
                  <a-input-number
                    type="number"
                    :min="0"
                    class="m-text-numberRight" style="width: 70%"
                    :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                    @keydown="onlyNumber"
                    disabled
                    v-decorator="['est_gross_profit', { rules: [{ required: true }], initialValue: modalCreate.data.est_gross_profit }]"
                  ></a-input-number>
              </div>
            </a-form-item> -->
            <a-form-item label="Est. Operasional Cost (IDR)">
              <a-input-number
                type="number"
                :min="0"
                class="m-width-full m-text-numberRight"
                :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                @keydown="onlyNumber"
                
                v-decorator="['est_operasional_cost', { rules: [{ required: true }], initialValue: modalCreate.data.est_operasional_cost }]"
              ></a-input-number>
            </a-form-item>
            <a-form-item label="Est. Marketing Cost (IDR)">
              <a-input-number
                type="number"
                :min="0"
                class="m-text-numberRight  m-width-full"
                :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                @keydown="onlyNumber"
                v-decorator="['est_marketing_cost', { rules: [{ required: true }], initialValue: modalCreate.data.est_marketing_cost }]"
              ></a-input-number>
            </a-form-item>
            <a-form-item label="Est. GA Cost (IDR)">
              <a-input-number
                type="number"
                :min="0"
                class="m-text-numberRight  m-width-full"
                :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                @keydown="onlyNumber"
                v-decorator="['est_ga_cost', { rules: [{ required: true }], initialValue: modalCreate.data.est_ga_cost }]"
              ></a-input-number>
            </a-form-item>
            <a-form-item label="Est. Finance Cost (IDR)">
              <a-input-number
                type="number"
                :min="0"
                class="m-text-numberRight  m-width-full"
                :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                @keydown="onlyNumber"
                
                v-decorator="['est_finance_cost', { rules: [{ required: true }], initialValue: modalCreate.data.est_finance_cost }]"
              ></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-item label="Status">
              <a-select
                placeholder="Select "
                v-decorator="['status', { rules: [{ required: true }], initialValue: modalCreate.data.status }]"
                class="width-full"
                disabled
              >
                <a-select-option value="PROSPECT">Prospect</a-select-option>
                <a-select-option value="CONTRACT">Contract</a-select-option>
                <a-select-option value="LOST">Lost</a-select-option>
                <a-select-option value="CANCEL">Cancel</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Category">
              <a-select
                placeholder="Select Category"
                v-decorator="['category', { rules: [{ required: true }], initialValue: modalCreate.data.category }]"
                class="width-full"
                initialValue
                allowClear
              >
                <a-select-option
                  v-for="item in kategori"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.text }}</a-select-option
                >
              </a-select>
            </a-form-item>
            <a-form-item label="Year">
              <a-select
                placeholder="Select "
                v-decorator="['year', { rules: [{ required: true }], initialValue: modalCreate.data.year }]"
                class="width-full"
              >
                <a-select-option  v-for="n in 5" :key="n-1" :value="Number(moment().format('YYYY'))+(n-1)">{{Number(moment().format('YYYY'))+(n-1)}}</a-select-option>
              </a-select>
            </a-form-item>
            <!-- <a-form-item label="Progress">
              <a-row :gutter="16">
                <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                  <a-input-number
                    type="number"
                    :min="0"
                    :max="100"
                    class="m-width-full m-text-numberRight"
                    :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                    @keydown="onlyNumber"
                    @change="changeProgress"
                    ref="refProgress"
                    v-decorator="['progress', { rules: [{ required: true }], initialValue: modalCreate.data.progress }]"
                  ></a-input-number>
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 18 }">
                  <a-progress :percent="modalCreate.progress" />
                </a-col>
              </a-row>
            </a-form-item> -->
            <a-form-item label="Note">
              <a-textarea
                placeholder="Write the note here ... "
                :rows="4"
                v-decorator="['note', { rules: [{ required: false }], initialValue: modalCreate.data.note }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "pipeline-index",
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === null) {
        callback(new Error("Please input value"));
      } else if (value <= 0) {
        callback(new Error("value must be greater than 0"));
      } else if (value > parseFloat(this.formModel.inputmax)) {
        callback(
          new Error(
            "Max value is " +
              this.formatCurrency(
                this.formModel.inputcurr,
                parseFloat(this.formModel.inputmax)
              )
          )
        );
      } else {
        this.$refs.ruleForm.validateField("inputEditvalue");
        callback();
      }
    };
    let type_tax_master = [
      { key: 'fee_lain_lain', title: 'Fee Lain-lain' },
      { key: 'commision', title: 'Komisi' },
      { key: 'pph_22_15',title:'PPh 22-15 %'},
      { key: 'pph_23', title: 'PPh 23' },
      { key: 'pph_21', title: 'PPh 21' },
      { key: 'pph_pasal4', title: 'PPh Pasal 4 ayat 2' },
      { key: 'pph_2529', title: 'PPh 25/29 Badan' },
      { key: 'ppn', title: 'PPN' },
      // {key:'ppn_dipungut',title:'PPN Dipungut'},
      // {key:'ppn_memungut',title:'PPN Memungut'},
      // {key:'ppn_migas',title:'PPN MIGAS'},
      // {key:'ppn_sktd',title:'PPN SKTD'},
      ];
    return {
      year_transaction: "all",
      listPipelineYear:[],
      modalCreate:{
        visible: false,
        type: "",
        loadingSave: false,
        progress: 0,
        data: {
          pipeline_id: null,
          definition: null,
          description: null,
          end_user: null,
          pic: null,
          pimpro: null,
          contact_details: null,
          currency: 'IDR',
          exchange_rate: 1,
          est_contract_value: null,
          // est_gross_profit: null,
          // est_gross_profit_prosen: null,
          est_operasional_cost: null,
          est_marketing_cost: null,
          est_ga_cost: null,
          est_finance_cost: null,
          status: null,
          category: null,
          year: null,
          progress: null,
          note: null,
        }
      },
      lblxchangerate:"",
      type_tax_master,
      table: {
        active: "needprocess",
        loading: false,
      },
      datasource: [],
      datasourceOrigin: [],
      search: undefined,
      sts_transaction: "all",
      advancedsearch: "display:none",
      buktiTransfer: [],
      modalUploadFile: false,
      poupModalEditData: false,
      formModel: {
        inputEditid: "",
        inputEdit_no: "",
        inputEdit_wk_nm: "",
        inputEditvalue: "",
        inputEditCUr: "IDR",
        inputEditjns: "",
        inputmax: 0,
        inputcurr: "",
      },
      rulesModel: {
        inputEditvalue: [
          { required: true, validator: validatePass, trigger: "blur" },
        ],
      },
      inputEditLoading: false,

      fileListModalLampiran: [],
      fileListDtlLampiran:[],
      pagination: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 10,
        size: "small",
      },
      tempCalc: {
        fee_lain: 0,
        pph22_15: 0,
        pph23: 0,
        komisi:0
      },
      deduction_source: [],
      paginationDeduction: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 10,
        size: "small",
      },
      deductionDataEdit: [],
      loading: {
        release: false,
        idrelease: "",
        submitARGeneral:false
      },
      modalARGeneral: false,
      fileListModalARGeneral: [],
      labelKanban: [
        {label: "PROSPECT"},
        {label: "CONTRACT"},
        {label: "LOST"},
        {label: "CANCEL"},
      ],
      kategori: [],
      excel_table:[],
      dataTable: [],
      dataTableOrigin: [],
      loadingExport: false,
      typeView: "board",
      akun_Manager: [],
      custNameList:[],
      prospectList:[],
    };
  },
  mounted() {
    if (this.getAuth.divisi[0] == "Akuntansi") {
      this.tabs.active = "release";
    }
    Event.$on("handleCancel", this.cancelAR);
    this.$store.dispatch("FETCH_ALL_MATA_UANG");
  },
  beforeDestroy() {
    Event.$off("handleCancel", this.cancelAR);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getAllMataUang",
      "getAllKaryawan",
    ]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
      const columns = [
          {
            title: "#",
            key: "nomor",
            scopedSlots: { customRender: "nomor" },
            width: 40,
            align: "center",
          },
          {
            title: "Status",
            key: "sts",
            scopedSlots: { customRender: "status" },
            align: "center",
            width: 100,
          },
          {
            title: "Pipeline Number / Product Name",
            key: "cd_dev",
            scopedSlots: { customRender: "cd_dev" },
            width: 250,
            align: "left",
          },
          {
            title: "Year / TLC Create",
            key: "create_tlc",
            scopedSlots: { customRender: "create_tlc" },
            width: 150,
            align: "center",
          },
          {
            title: "Description",
            key: "desc",
            dataIndex: "description",
            width: 250,
          },
          {
            title: "Customer",
            key: "client",
            dataIndex: "client",
            width: 200,
          },
          {
            title: "Est. Contract Value",
            key: "ecv",
            scopedSlots: { customRender: "ecv" },
            width: 150,
            align: "right",
          },
          {
            title: "Est. Cost",
            key: "ec",
            scopedSlots: { customRender: "ec" },
            width: 150,
            align: "right",
          },
          {
            title: "Est. Profit/Lost",
            key: "epl",
            scopedSlots: { customRender: "epl" },
            width: 150,
            align: "right",
          },
          {
            title: "",
            key: "action",
            width: 100,
            scopedSlots: { customRender: "aksi" },
            fixed: this.getScreen ? false : "right",
            align: "center",
          },
        ];
      return columns;
    },
    moreSearch: function () {
      let tempData = [];
      if(this.typeView=='board'){
        tempData[0] = this.datasourceOrigin[0]
        tempData[1] = this.datasourceOrigin[1]
        tempData[2] = this.datasourceOrigin[2]
        tempData[3] = this.datasourceOrigin[3]
        if(this.search){
          tempData[0] = tempData[0].filter(
            (obj) => (
              obj.pipeline_no && obj.pipeline_no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
              || (obj.tlc_create && obj.tlc_create.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
              || (obj.create_dt && moment(obj.create_dt).format('DD-MM-YYYY').toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
              || (obj.client && obj.client.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
              || (obj.definitions && obj.definitions.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
              || (obj.description && obj.description.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
          );

          tempData[1] = tempData[1].filter(
            (obj) => (
              obj.pipeline_no && obj.pipeline_no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
              || (obj.tlc_create && obj.tlc_create.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
              || (obj.create_dt && moment(obj.create_dt).format('DD-MM-YYYY').toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
              || (obj.client && obj.client.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
              || (obj.definitions && obj.definitions.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
              || (obj.description && obj.description.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
          )

          tempData[2] = tempData[2].filter(
            (obj) => (
              obj.pipeline_no && obj.pipeline_no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
              || (obj.tlc_create && obj.tlc_create.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
              || (obj.create_dt && moment(obj.create_dt).format('DD-MM-YYYY').toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
              || (obj.client && obj.client.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
              || (obj.definitions && obj.definitions.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
              || (obj.description && obj.description.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
          );

          tempData[3] = tempData[3].filter(
            (obj) => (
              obj.pipeline_no && obj.pipeline_no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
              || (obj.tlc_create && obj.tlc_create.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
              || (obj.create_dt && moment(obj.create_dt).format('DD-MM-YYYY').toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
              || (obj.client && obj.client.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
              || (obj.definitions && obj.definitions.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
              || (obj.description && obj.description.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
          );
        }

        if (this.year_transaction && this.year_transaction !== "all") {
          tempData[0] = tempData[0].filter(
            (obj) =>
              obj.year &&
              obj.year.toLowerCase() ==
                this.year_transaction.toLowerCase()
          );
          tempData[1] = tempData[1].filter(
            (obj) =>
              obj.year &&
              obj.year.toLowerCase() ==
                this.year_transaction.toLowerCase()
          );
          tempData[2] = tempData[2].filter(
            (obj) =>
              obj.year &&
              obj.year.toLowerCase() ==
                this.year_transaction.toLowerCase()
          );
          tempData[3] = tempData[3].filter(
            (obj) =>
              obj.year &&
              obj.year.toLowerCase() ==
                this.year_transaction.toLowerCase()
          );
        }
      }else{
        tempData = this.dataTableOrigin;
        if (tempData.length > 0) {
          if (this.search) {
            tempData = tempData.filter(
              (obj) =>
                obj.searchQ &&
                obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
            );
          }

          // if (this.sts_transaction && this.sts_transaction !== "all") {
          //   tempData = tempData.filter(
          //     (obj) =>
          //       obj.status &&
          //       obj.status.toLowerCase() ==
          //         this.sts_transaction.toLowerCase()
          //   );
          // }

          if (this.year_transaction && this.year_transaction !== "all") {
            tempData = tempData.filter(
              (obj) =>
                obj.year &&
                obj.year.toLowerCase() ==
                  this.year_transaction.toLowerCase()
            );
          }
        }
      }

      this.excel_table = []
      if (this.year_transaction && this.year_transaction !== "all") {
        let a = this.datasourceOrigin[0].filter(
            (obj) =>
              obj.year &&
              obj.year.toLowerCase() ==
                this.year_transaction.toLowerCase()
          );
        let b = this.datasourceOrigin[1].filter(
            (obj) =>
              obj.year &&
              obj.year.toLowerCase() ==
                this.year_transaction.toLowerCase()
          );
        let c = this.datasourceOrigin[2].filter(
            (obj) =>
              obj.year &&
              obj.year.toLowerCase() ==
                this.year_transaction.toLowerCase()
          );
        let d = this.datasourceOrigin[3].filter(
            (obj) =>
              obj.year &&
              obj.year.toLowerCase() ==
                this.year_transaction.toLowerCase()
          );

        this.excel_table = this.excel_table.concat(a).concat(b).concat(c).concat(d);
      }else{
        this.excel_table = this.excel_table.concat(this.datasourceOrigin[0])
          .concat(this.datasourceOrigin[1]).concat(this.datasourceOrigin[2]).concat(this.datasourceOrigin[3]);
      }

      if (
        !this.search 
        // &&
        // !this.sts_transaction &&
        && !this.year_transaction
      ) {
        this.intoList(null, tempData);
      }else{
        this.intoList(this.typeView, tempData);
      }
      return true;
    },
    initCUr() {
      return this.symbolCurrencyES6(this.formModel.inputEditCUr, 0);
    },
    curReplace() {
      return eval(
        "/\\" +
          this.symbolCurrencyES6(this.formModel.inputEditCUr, 1) +
          "\\s?|(,*)/g"
      );
    },
    realAR() {
      return (
        parseFloat(this.formModel.inputEditValue) - this.totalDeduction
      );
    },
    pageType(){
      if (this.getAuth.divisi[0] == "Akuntansi") {
        this.tabs.active = "release";
      }
      return this.tabs.active
    },
    totalDeduction(){
      let res = 0;
      if(this.deduction_source.length>0)
        this.deduction_source.forEach((element) => {
          res += Number(element.value_tax)
        });
      return res;
    },
    deductionDataisEditing(){
      return !_.isEmpty(this.deductionDataEdit);
    },
    excel_columns(){
      return [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 40,
          align: "center",
        },
        {
          title: "Status",
          key: "status",
          dataIndex: "status",
          align: "left",
        },
        {
          title: "Pipeline Number",
          key: "pipeline_no",
          dataIndex: "pipeline_no",
          align: "left",
        },
        {
          title: "Product",
          key: "produk",
          dataIndex: "definitions",
          align: "left",
        },
        {
          title: "Description",
          key: "description",
          dataIndex: "description",
          align: "left",
        },
        {
          title: "Customer Name",
          key: "client",
          dataIndex: "client",
          align: "left",
        },
        {
          title: "Account manager",
          key: "pic_am",
          dataIndex: "pic_am",
          align: "left",
        },
        {
          title: "PIMPRO",
          key: "pic_pimpro",
          dataIndex: "pic_pimpro",
          align: "left",
        },
        // {
        //   title: "Currency",
        //   key: "currency",
        //   dataIndex: "currency",
        //   align: "left",
        // },
        {
          title: "Est. Contract Value (IDR)",
          key: "est_contract_value",
          scopedSlots: { customRender: "est_contract_value" },
          align: "right",
        },
        {
          title: "Est Operasional Cost (IDR)",
          key: "est_operasional_cost",
          scopedSlots: { customRender: "est_operasional_cost" },
          align: "right",
        },
        {
          title: "Est Marketing Cost (IDR)",
          key: "est_marketing_cost",
          scopedSlots: { customRender: "est_marketing_cost" },
          align: "right",
        },
        {
          title: "Est GA Cost (IDR)",
          key: "est_ga_cost",
          scopedSlots: { customRender: "est_ga_cost" },
          align: "right",
        },
        {
          title: "Est Finance Cost (IDR)",
          key: "est_finance_cost",
          scopedSlots: { customRender: "est_finance_cost" },
          align: "right",
        },
        {
          title: "Prospect Progress",
          key: "prospect_progress",
          scopedSlots: { customRender: "prospect_progress" },
          align: "right",
        },
        // {
        //   title: "Exchange rate (Rp.)",
        //   key: "kurs",
        //   dataIndex: "kurs",
        //   align: "right",
        // },
        {
          title: "Year",
          key: "year",
          dataIndex: "year",
          align: "left",
        },
        {
          title: "Category",
          key: "kategori",
          dataIndex: "kategori",
          align: "left",
        },
        {
          title: "Note",
          key: "notes",
          dataIndex: "notes",
          align: "left",
        },
      ]
    },
    isMarketing(){
      return this.$route.path=='/marketing/pipeline'
    },
    isKeuangan(){
      let data = _.filter(this.getAuth.nama_bidang,(obj) => obj=="Keuangan");
      return data.length>0 ? true : false;
    },
  },
  created() {
    this.$store.dispatch("FETCH_ALL_KARYAWAN");
    this.handleReload().then(()=>{
      this.year_transaction = moment().format('YYYY')
    });
  },
  beforeCreate() {
    this.formLampiran = this.$form.createForm(this);
    this.formDeduction = this.$form.createForm(this);
    this.formCreateEdit = this.$form.createForm(this);
  },
  methods: {
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    resetSearch() {
      this.search           = undefined;
      this.year_transaction = moment().format('YYYY').toString();
      this.sts_transaction  = "all";
    },
    intoList(type, value) {
      if (type == null) {
        this.dataTable = this.dataTableOrigin;
        this.datasource = this.datasourceOrigin;
      }else{
        if(type=='board'){
          this.datasource = value;
        }else{
          this.dataTable = value;
        }
      }
    },
    async handleReload() {
      this.table.loading = true;
      let urlfetch = "getPipelineList";
      await this.$store
        .dispatch(urlfetch, {})
        .then(
          (res) => {
            this.custNameList = res.data.customer;
            this.prospectList = res.data.prospek;
            this.datasource=[]
            this.datasource.push(res.data.prospect);
            this.datasource.push(res.data.contract);
            this.datasource.push(res.data.lost);
            this.datasource.push(res.data.cancel);
            this.datasourceOrigin = this.datasource;
            this.kategori = res.data.kategori
            this.excel_table = this.excel_table.concat(res.data.prospect)
              .concat(res.data.contract)
                .concat(res.data.lost).concat(res.data.cancel);
           _.forEach(this.excel_table, (data, index) => {
             this.excel_table[index].searchQ =
               this.excel_table[index].pipeline_no +
              // this.excel_table[index].cost_center_kode +
               this.excel_table[index].definitions +
               this.formatCurrency(
                 this.excel_table[index].currency,
                 this.excel_table[index].up_value
               ) +
               this.formatCurrency(
                 this.excel_table[index].currency,
                 this.excel_table[index].est_contract_value
               ) +
               this.formatCurrency(
                 this.excel_table[index].currency,
                 this.excel_table[index].estimate_gross_profit
              ) +
               this.excel_table[index].client +
              //  this.excel_table[index].pic_am +
              //  this.excel_table[index].pic_pimpro +
               this.excel_table[index].contact_detail +
               this.excel_table[index].status +
               this.excel_table[index].status_besar +
               this.excel_table[index].year + 
               this.excel_table[index].tlc_create + 
                moment(this.excel_table[index].create_dt).format(
                this.getDefaultDateFormat
               );
           });

           this.dataTable = this.excel_table;
           this.dataTableOrigin = this.excel_table;
           this.listPipelineYear = _.uniq(_.map(this.dataTableOrigin, "year"));

           
            this.table.loading = false;
          },
          (error) => {
            this.dataTable = [];
            this.dataTableOrigin = [];

            let responses = Object.assign({}, error);
            this.displayMessageValue("error-other", responses);
            this.table.loading = false;
          }
        );

        const akunManager = axios({
          method: "get",
          url: this.$serviceUrl + "project/akun_manajer",
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey
          }
        }).catch(err => {
          console.log(err);
        });

        return axios
        .all([akunManager.catch(err => {
            return null;
          })]).then(response => {
            if (response[0] !== undefined) {
              this.akun_Manager = response[0].data.data
            }
          })
        
      this.resetSearch();
    },
    handleTab(val) {
      this.tabs.active = val;
      this.resetSearch();
    },
    //handleCreate(item) {
    //  this.$router.push({
    //   name: "createNgeneral-account-receive",
    //    params: { id: item.id },
    //  });
    //},
    handleCancelButton(item) {
      this.confirmMessageValue("confirm-cancel", item, null);
    },
    cancelAR(item) {
      this.tabs.loading = true;
      this.$store
        .dispatch("releaseAR", {
          auth: this.getAuth,
          id: item.id,
          jenis_transaksi:
            item.jenis_transaksi == "Penerimaan Kontrak"
              ? "Penerimaan_Kontrak"
              : "Piutang_lain_lain",
        })
        .then((response) => {
          this.tabs.loading = false;
          this.formModel.inputEditid = "";
          this.formModel.inputEditjns = "";
          this.displayMessageValue("success-other", response.message);
          this.handleReload();
        })
        .catch((error) => {
          this.tabs.loading = false;
          let responses = Object.assign({}, error);
          if (responses.response.data) {
            this.displayMessageValue(
              "error-other",
              responses.response.data.message
            );
          } else {
            this.displayMessageValue("error-other", responses.response);
          }
        });
    },
    handleManifest(item) {
      if (
        this.tabs.active == "needprocess" &&
        item.jenis_transaksi == "Penerimaan Kontrak"
      ) {
        this.$router.push({
          name: "manifestSalesContractKeu",
          params: {
            p_auth: { username: item.user_pembuat },
            tlc_pembuat: item.user_pembuat,
            id: item.id,
          },
        });
      } else {
        this.$router.push({
          name:
            this.getAuth.divisi == "Keuangan"
              ? "account-receive-manifest"
              : "account-receivable-manifest",
          params: {
            id: item.id,
            tab: this.tabs.active,
            jns:
              item.jenis_transaksi == "Penerimaan Kontrak"
                ? "Penerimaan_Kontrak"
                : "Piutang_lain_lain",
          },
        });
      }
    },
    handleUpload(item) {
      if (item.jenis_transaksi == "Piutang lain - lain") {
        this.modalARGeneral = true;
        this.$nextTick(function () {
          this.formCreateEdit.setFieldsValue({
            id: item.id,
            jenis_transaksi: item.jenis_transaksi,
          });
        });
      } else {
        if (item.status == 'Revised') {
          this.asyncAxiosGet(
            "account_receivable/proses",
            this.getAuth,
            {
              id: item.id,
            }
          ).then((response) => {
            this.deduction_source = response.dtl;
            this.modalUploadFile = true;
            this.formModel = {
              ...this.formModel,
              inputEditid: item.id,
              inputEditjns: item.jenis_transaksi,
              inputEditCUr: item.currency,
              inputEditValue: item.value,
            };

            let file = null;
            if (response.upload_document_file != null) {
              let typefile = this.fileTypeFromUrl(response.upload_document_name);
              file = this.dataURLtoFile(typefile + response.upload_document_file, response.upload_document_name);
              file.uid = 'vc-upload-1-1';
              file.status = 'done';
              file.exist = true;
              file.url = this.$serviceUrl + response.upload_document_path;
              this.fileListModalLampiran = [];
              this.fileListModalLampiran.push(file);
            }
            this.$nextTick(function () {
                this.formLampiran.setFieldsValue({
                  document_name: response.document_name,
                  upload_document_file: file
                });
              });
          }).catch((err) => {
            console.log(err);
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
          });
        } else {
          this.modalUploadFile = true;
          this.formModel = {
            ...this.formModel,
            inputEditid: item.id,
            inputEditjns: item.jenis_transaksi,
            inputEditCUr: item.currency,
            inputEditValue: item.value,
          };
        }
      }
    },
    handleDocument(item) {
      window.open(this.$serviceUrl + item.file_path, "_blank");
    },
    handleClose() {
      this.modalUploadFile = false;
    },
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },
    handleRevisiAndClose(item) {
      const that = this;
      let title = "";
      let messageSukses = "";
      title = "Are you sure to revise this data";
      messageSukses = "Successfully revise data";

      this.$confirm({
        title: title,
        content: "Batal / OK?",
        onOk() {
          let promise = new Promise((resolve, reject) => {
            let data = {
              tlc: that.getAuth.username,
              aksi: item.button_aksi,
              id: item.id,
              jenis_transaksi: item.jenis_transaksi,
            };

            axios({
              method: "post",
              url: that.$serviceUrl + "account_pay/aksi_account_pay",
              data: data,
              auth: {
                username: that.getAuth.username,
                password: that.getAuth.password,
              },
              headers: {
                "Content-Type": "application/json",
                "X-API-KEY": that.getAuth.apikey,
              },
            })
              .then(({ data }) => {
                resolve(data);
              })
              .catch((err) => {
                reject(err);
              });
          }).catch(() => console.log("Oops errors!"));
          promise
            .then(() => {
              that.displayMessageValue("success-other", messageSukses);
              that.handleReload();
            })
            .then((err) => {
              if (err) {
                let responses = Object.assign({}, err.response.data);
                that.displayMessageValue("error-other", responses.message);
              }
            });
          return promise;
        },
        onCancel() {},
      });
    },
    handleShowValue(val) {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields();
      }
      this.formModel.inputEditvalue = val.remaining ? val.remaining : 0;
      this.formModel.inputEditCUr = val.currency;
      this.formModel.inputEdit_no = val.no_transaction;
      this.formModel.inputEdit_wk_nm = val.work_nm;
      this.formModel.inputEditid = val.id;
      this.formModel.inputmax = val.remaining ? parseFloat(val.remaining) : 0;
      this.formModel.inputcurr = val.currency;
      this.poupModalEditData = true;
    },
    simpanEditData() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        this.inputEditLoading = true;

        let post = new FormData();
        post.append("tlc", this.getAuth.username);
        post.append("id", this.formModel.inputEditid);
        post.append("value", this.formModel.inputEditvalue);

        if (parseFloat(this.formModel.inputEditvalue) <= 0) {
          this.displayMessageValue(
            "error-other",
            "Value must be greater than 0"
          );
          this.inputEditLoading = false;
          return;
        }

        axios({
          method: "post",
          url: this.$serviceUrl + "account_receivable/ar_general_input_value",
          processData: false,
          data: post,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.inputEditLoading = false;
            this.poupModalEditData = false;
            this.displayMessage("success-edit");
            this.handleReload();
          })
          .catch((error) => {
            this.inputEditLoading = false;
            let responses = Object.assign({}, error);
            if (responses.response.data) {
              this.displayMessageValue(
                "error-other",
                responses.response.data.message
              );
            } else {
              this.displayMessageValue("error-other", responses.response);
            }
          });
      });
    },
    cancelEditData() {
      this.poupModalEditData = false;
    },
    handleCreate() {
      this.modalCreate.type = 'create';
      this.modalCreate.data = {
          pipeline_id: null,
          definition: null,
          description: null,
          end_user: null,
          pic: null,
          pimpro: null,
          contact_details: null,
          currency: 'IDR',
          exchange_rate: 1,
          est_contract_value: null,
          // est_gross_profit: null,
          // est_gross_profit_prosen: null,
          est_operasional_cost: null,
          est_marketing_cost: null,
          est_ga_cost: null,
          est_finance_cost: null,
          status: "PROSPECT",
          category: null,
          year: null,
          progress: null,
          note: null,
      }
      this.modalCreate.progress = 0 
      this.modalCreate.visible = true;
    },
    // handleEditButton(data) {
    //   this.$router.push({
    //     name: "editNgeneral-account-receive",
    //     params: { id: data.id },
    //   });
    // },
    addLampiran(e) {
      e.stopPropagation();
      this.visibleLampiran = !this.visibleLampiran;
    },
    cancelLampiran() {
      this.tempCalc = {
        fee_lain: 0,
        pph22_15: 0,
        pph23: 0,
        komisi: 0,
      };
      this.fileListModalLampiran = [];
      this.deduction_source = [];
      this.formLampiran.resetFields();
      this.modalUploadFile = false;
    },
    handleRemoveModal(file) {
      const index = this.fileListModalLampiran.indexOf(file);
      const newFileList = this.fileListModalLampiran.slice();
      newFileList.splice(index, 1);
      this.fileListModalLampiran = newFileList;
    },
    handleRemoveDtl(file){
      const index = this.fileListDtlLampiran.indexOf(file);
      const newFileList = this.fileListDtlLampiran.slice();
      newFileList.splice(index, 1);
      this.fileListDtlLampiran = newFileList;
    },
    handleRemoveModalARGeneral() {
      this.fileListModalARGeneral = [];
    },
    beforeUploadModal(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 10) {
        this.displayMessage("large-file-10mb");
      } else {
        this.fileListModalLampiran = [];
        this.fileListModalLampiran.push(file);
      }
      return false;
    },
    beforeUploadDtl(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 10) {
        this.displayMessage("large-file-10mb");
      } else {
        this.fileListDtlLampiran = [];
        this.fileListDtlLampiran.push(file);
      }
      return false;
    },
    beforeUploadModalARGeneral(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 10) {
        this.displayMessage("large-file-10mb");
      } else {
        this.fileListModalARGeneral = [];
        this.fileListModalARGeneral.push(file);
      }
      return false;
    },
    handleAddEditDtl() { 
      this.formLampiran.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        if (this.fileListModalLampiran.length == 0) {
          this.displayMessage("form-warning");
          return;
        }

        if (this.deduction_source.length == 0) {
          this.displayMessageValue("error-other", "List Details Can't be empty!");
          return;
        }

        if(this.realAR<0){
          this.displayMessageValue("error-other", "Real Value AR Can't be minus!");
          return;
        }

        let formData = new FormData();
        formData.append("tlc", this.getAuth.username);
        formData.append("id", this.formModel.inputEditid);
        formData.append("jenis_transaksi", this.formModel.inputEditjns);
        formData.append("document_name", values.document_name);
        formData.append("upload_document_file", this.fileListModalLampiran[0]);

        this.deduction_source.forEach((element,index) => {
          if(element.id_dtl)
            formData.append(`id_dtl[${index}]`, element.id_dtl);
          formData.append(`type_tax[${index}]`, element.type_tax ? element.type_tax : "");
          formData.append(`description[${index}]`, element.description ? element.description : "");
          formData.append(`value_tax[${index}]`, element.value_tax ? element.value_tax : "");
          if(element.upload_tax_document && element.upload_tax_document.file)
          formData.append(`upload_tax_document[${index}]`, element.upload_tax_document.file);
        });

        this.inputEditLoading = true;
        axios({
          method: "post",
          url: this.$serviceUrl + "account_receivable/proses",
          processData: false,
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.inputEditLoading = false;

            this.formModel.inputEditid = "";
            this.formModel.inputEditjns = "";
            this.formLampiran.resetFields();

            this.displayMessage("success-upload");
            this.modalUploadFile = !this.modalUploadFile;
            this.tempCalc = {
              fee_lain: 0,
              pph22_15: 0,
              pph23: 0,
              komisi: 0,
            };
            this.fileListModalLampiran = [];
            this.deduction_source = [];
            this.handleReload();
          })
          .catch((error) => {
            this.inputEditLoading = false;

            let responses = Object.assign({}, error);
            if (responses.response.data) {
              this.displayMessageValue(
                "error-other",
                responses.response.data.message
              );
            } else {
              this.displayMessageValue("error-other", responses.response);
            }
          });
      });
    },
    handleAddEditItem(){
      this.formDeduction.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let exist = _.filter(this.deduction_source,(item)=> item.type_tax==values.type_tax 
          && item.description.toLowerCase()==values.description.toLowerCase());
        if(exist.length>0){
          this.displayMessageValue("error-other", "Data with type and description entry is exist!");
          return;
        }

        this.deduction_source.push(values);
        this.formDeduction.resetFields();
        this.fileListDtlLampiran = [];
      });
    },
    gettitletax(val){
      let res = _.filter(this.type_tax_master,(el)=>el.key==val);
      return res[0].title;
    },
    viewFiledtl(val){
      let typefile = this.fileTypeFromUrlBasic(val.upload_tax_document.file.name);
      let blob = new Blob([val.upload_tax_document.file], { type: typefile, }),
      url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
    },
    editdtl(val, index) {
      if (val.upload_tax_document_path) {
        this.asyncAxiosGet("main/base_64", this.getAuth, {
          path: val.upload_tax_document_path,
        })
        .then((response) => {
          let typefile = this.fileTypeFromUrl(val.upload_tax_document_name);
          let file = this.dataURLtoFile(
            typefile + response.file_document_tax,
            val.upload_tax_document_name
          );
          file.uid = "vc-upload-1-1";
          file.status = "done";
          file.url = this.$serviceUrl + val.upload_tax_document_path;

          this.deductionDataEdit = val;
          this.deductionDataEdit['index'] = index;
          this.upload_tax_document = [];
          this.upload_tax_document.push(file);
          this.fileListDtlLampiran.push(file);
          this.$nextTick(function () {
              this.formDeduction.setFieldsValue({
                upload_tax_document: file,
              });
            });
        })
        .catch((err) => {
          console.log(err);
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
      } else {
        this.deductionDataEdit = val;
        this.deductionDataEdit['index'] = index;
        if (val.upload_tax_document && val.upload_tax_document.file) {
          this.fileListDtlLampiran.push(val.upload_tax_document.file);
        } else {
          this.fileListDtlLampiran = [];
        }
      }
    },
    deletedtl(index){
      this.deduction_source.splice(index, 1);
    },
    handleCancelEditItem(){
      this.deductionDataEdit = [];
      this.fileListDtlLampiran = [];
    },
    handleChangeEditItem(){
      this.formDeduction.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let editkeyIndex = this.deductionDataEdit.index;
        let exist = _.filter(this.deduction_source,(item,index)=> item.type_tax==values.type_tax 
          && item.description.toLowerCase()==values.description.toLowerCase() && index!=editkeyIndex);
        if(exist.length>0){
          this.displayMessageValue("error-other", "Data with type and description entry is exist!");
          return;
        }
        this.deduction_source[editkeyIndex].type_tax = values.type_tax;
        this.deduction_source[editkeyIndex].description = values.description;
        this.deduction_source[editkeyIndex].value_tax = values.value_tax;
        if (this.fileListDtlLampiran.length > 0) {
          if (this.deduction_source[editkeyIndex].upload_tax_document) {
            this.deduction_source[editkeyIndex].upload_tax_document = { file: this.fileListDtlLampiran[0] };
          } else {
            this.deduction_source[editkeyIndex]['upload_tax_document'] = [];
            this.deduction_source[editkeyIndex].upload_tax_document = { file: this.fileListDtlLampiran[0] };
          }
        } else {
          this.deduction_source[editkeyIndex].upload_tax_document = null;
        }
        this.formDeduction.resetFields();
        this.deductionDataEdit = [];
        this.fileListDtlLampiran = [];
      });
    },
    getcolortage(item){
      let result = "";
      if(item=="On Process"){
        result = "orange";
      }else if(item=="Revised"){
        result = "red";
      }else if(item=="Verified"){
        result = "green";
      }
      return result;
    },
    handleReleaseButton(item) {
      const that = this;
      this.loading.idrelease = item.id;

      this.$confirm({
        title: "Are you sure to release this data?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          let data = new FormData();
          data.append("id", item.id);

          that.loading.release = true;
          that.asyncAxiosPost(
            "account_receivable/rilis_ar_sc",
            "formdata",
            that.getAuth,
            data
          )
          .then(() => {
            that.displayMessage("success-release");
            that.loading.release = false;
            that.loading.idrelease = "";
            that.handleReload();
          })
          .catch((err) => {
            that.loading.release = false;
            that.loading.idrelease = "";
            let response = Object.assign({}, err.response);
            if (response.data.status == false && response.data.message) {
              that.displayMessageValue("error-other", response.data.message);
            } else {
              let responses = Object.assign({}, err.response.data);
              that.displayMessageValue("error", responses);
            }
          });
        },
        onCancel() { },
      });
    },
    submitCreateEdit() {
      this.formCreateEdit.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
          let formData = new FormData();
          if(values.id_prospek)
            formData.append("id_prospek", values.id_prospek);
          formData.append("definition", values.definition);
          formData.append("description", values.description);
          formData.append("end_user", values.end_user);
          if(values.pic)
            formData.append("pic", values.pic);
          if(values.pimpro)
            formData.append("pimpro", values.pimpro);
          if(values.contact_details)
            formData.append("contact_details", values.contact_details);
          formData.append("currency", values.currency);
          formData.append("exchange_rate", values.exchange_rate);
          formData.append("est_contract_value", values.est_contract_value);
          // formData.append("est_gross_profit", values.est_gross_profit);
          // formData.append("est_gross_profit_prosen", values.est_gross_profit_prosen);
          formData.append("est_operasional_cost", values.est_operasional_cost);
          formData.append("est_marketing_cost", values.est_marketing_cost);
          formData.append("est_ga_cost", values.est_ga_cost?values.est_ga_cost:0);
          formData.append("est_finance_cost", values.est_finance_cost);
          formData.append("status", values.status);
          formData.append("kategori", values.category);
          formData.append("year", values.year);
          // formData.append("progress", values.progress);
          formData.append("note", values.note ? values.note : "");

          this.modalCreate.loadingSave = true;
          axios({
            method: "post",
            url: this.$serviceUrl + (this.modalCreate.type=='create' ? "pipeline" : "pipeline/edit"),
            processData: false,
            data: formData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then(() => {
              this.modalCreate.loadingSave = false;

              this.formCreateEdit.resetFields();
              this.modalCreate.visible = false;

              if(this.modalCreate.type=='create'){
                this.displayMessage("success-save");
              }else{
                this.displayMessage("success-edit");
              }
              this.handleReload();
            })
            .catch((error) => {
              this.modalCreate.loadingSave = false;

              let responses = Object.assign({}, error);
              if (responses.response.data) {
                this.displayMessageValue("error-other", responses.response.data.message);
              } else {
                this.displayMessageValue("error-other", responses.response);
              }
            });
      });
    },
    handleEdit(data){
      this.modalCreate.data.id_prospek= data.id_prospek
      this.modalCreate.data.pipeline_id= data.pipeline_id
      this.modalCreate.data.definition = data.definitions
      this.modalCreate.data.description = data.description
      this.modalCreate.data.end_user = data.client
      this.modalCreate.data.pic = data.pic_am
      this.modalCreate.data.pimpro = data.pic_pimpro
      this.modalCreate.data.contact_details = data.contact_detail
      this.modalCreate.data.currency = data.currency
      this.modalCreate.data.exchange_rate = data.kurs
      this.modalCreate.data.est_contract_value = data.est_contract_value
      // this.modalCreate.data.est_gross_profit = data.estimate_gross_profit
      // this.modalCreate.data.est_gross_profit_prosen = data.estimate_gross_profit_prosen
      this.modalCreate.data.est_operasional_cost = data.est_operasional_cost
      this.modalCreate.data.est_marketing_cost = data.est_marketing_cost
      this.modalCreate.data.est_ga_cost = data.est_ga_cost
      this.modalCreate.data.est_finance_cost = data.est_finance_cost
      this.modalCreate.data.status = data.status
      this.modalCreate.data.category = data.category
      this.modalCreate.data.year = data.year
      this.modalCreate.data.progress = data.progress
      this.modalCreate.progress = data.progress ? Number(data.progress) : 0
      this.modalCreate.data.note = data.notes
      this.modalCreate.type = "edit"
      this.modalCreate.visible = true
    },
    cancelmodalcreate() {
      this.modalCreate.visible = false

      // this.formCreateEdit.resetFields();
      // this.fileListModalARGeneral = [];
      // this.modalARGeneral = false;
    },
    handleChangeCurrency(value){
      if(value=='IDR'){
        this.lblxchangerate = ""
        this.modalCreate.data.exchange_rate = 1
      }else{
        this.lblxchangerate = " to IDR"
      }
    },
    changeProgress(val){
      if(val>100 || val<0){
        return false
      } else {
        this.modalCreate.progress = val;
      }
    },
    editActivity(params){
      let name = "pipeline-manifest"
      if(this.$route.path=='/vpf/pipeline'){
        name = "pipeline-manifestVpf"
      }else if(this.$route.path=='/akuntansiKeuangan/pipeline'){
        name = "pipeline-manifestAcc"
      }else if(this.$route.path=='/financialControl/pipeline'){
        name = "pipeline-manifestFin"
      }else if(this.$route.path=='/direktur/pipeline'){
        name = "pipeline-manifestDir"
      }else if(this.$route.path=='/keuangan/pipeline'){
        name = "pipeline-manifestKeu"
      }

      this.$router.push({
      name: name,
        params: { id: params.pipeline_id },
      });
    },
    changeprosen(val){
      let est_contract_value = this.formCreateEdit.getFieldValue("est_contract_value");
      this.formCreateEdit.setFieldsValue({est_gross_profit:(val/100)*(est_contract_value ? est_contract_value : 0)})
    },
    changeestcontrak(val){
      // let est_gross_profit_prosen = this.formCreateEdit.getFieldValue("est_gross_profit_prosen");
      // this.formCreateEdit.setFieldsValue({est_gross_profit: est_gross_profit_prosen ? (est_gross_profit_prosen/100)*val : 0})
    },
    handleExport(table, name) {
      // console.log('table', table)
      let uri = "data:application/vnd.ms-excel;base64,",
        template =
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>',
        base64 = function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format = function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        };
      if (!table.nodeType)
        table = document.getElementsByClassName("ant-table-export-excel");
      let ctx = { worksheet: name || "Worksheet", table: table[0].innerHTML };
      let a = document.createElement("a");
      a.href = uri + base64(format(template, ctx));
      a.download = "PipeLines.xls";
      a.click();
    },
    goTo(item){
      let res = "pipeline-manifest"
      if(this.$route.path=='/keuangan/pipeline'){
        res = "pipeline-manifestKeu"
      }else if(this.$route.path.includes('/akuntansiKeuangan/')){
        res = "pipeline-manifestAcc"
      }
      this.$router.push({
        name: res,
        params: {
          id: item.pipeline_id,
        },
      });
    }
  },
  watch:{
    search(){
      this.moreSearch
    },
    sts_transaction(){
      this.moreSearch
    },
    year_transaction(){
      this.moreSearch
    },
    typeView(){
      this.resetSearch()
      this.moreSearch
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);
  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border-bottom: 1px dashed darken(white, 10);
    padding: @padding;
  }
  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}

.result {
  margin: @padding 0;
  display: flex;
  justify-content: space-between;
}
</style>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }
    &-tabs-content {
      flex: 1;
    }
  }
}

.ant-table-thead > tr > th {
  text-align: center !important;
}

.listItem{
  cursor: pointer;
  &:hover {
    // background-color: fade(@color-secondary, 5%);
    background-color: darken(@color-read, 2%);
  }
}

.collapseItem { 
  .ant-collapse-content {
    .ant-collapse-content-box {
      padding: 0px!important;
    }
  }
}
.listItem.ant-list-item.ant-list-item-no-flex{
  padding: 16px;
}
.m-text-numberRight{
  input{
    text-align: right !important;
    padding-right: 25px;
  }
}
</style>
